import type { EntityRegistryEntry } from '../types';
import { getGroupWarnings } from '../../validation/groupValidation';

export const groupConfig: EntityRegistryEntry = {
    getWarnings: (data) => getGroupWarnings(data),
};
